module.exports = __webpack_public_path__ + "img/homeicon01@2x_wps.24e3a878.png";